// extracted by mini-css-extract-plugin
export var ad = "blogPage-module--ad--c0a18";
export var affiliateDisclaimer = "blogPage-module--affiliate-disclaimer--8b966";
export var amazon = "blogPage-module--amazon--bfec0";
export var amazonBlock = "blogPage-module--amazon-block--1ac29";
export var amazonImage = "blogPage-module--amazon-image--ef45b";
export var authorBio = "blogPage-module--author-bio--32618";
export var authorBlock = "blogPage-module--author-block--036f0";
export var authorImg = "blogPage-module--author-img--2e396";
export var authorName = "blogPage-module--author-name--85a22";
export var authorPic = "blogPage-module--author-pic--06a62";
export var authorTextBlock = "blogPage-module--author-text-block--5ca82";
export var blogBody = "blogPage-module--blog-body--76641";
export var blogContainer = "blogPage-module--blog-container--b8993";
export var blogDate = "blogPage-module--blog-date--95695";
export var blogSignature = "blogPage-module--blog-signature--adad9";
export var blogTitle = "blogPage-module--blog-title--f23df";
export var breadcrumbLink = "blogPage-module--breadcrumbLink--58f93";
export var btnBox = "blogPage-module--btn-box--79079";
export var btnCenter = "blogPage-module--btn-center--cea67";
export var btnContainer = "blogPage-module--btn-container--199e2";
export var btnOutline = "blogPage-module--btn-outline--d8351";
export var categories = "blogPage-module--categories--aa26d";
export var desktopAd = "blogPage-module--desktop-ad--12aaf";
export var gif = "blogPage-module--gif--cf6b1";
export var h2 = "blogPage-module--h2--f51a3";
export var heroImage = "blogPage-module--hero-image--db614";
export var imageBlock = "blogPage-module--image-block--41a1b";
export var imageCaption = "blogPage-module--image-caption--584ac";
export var jumpButton = "blogPage-module--jump-button--fffe2";
export var jumpContainer = "blogPage-module--jump-container--b3726";
export var mailerLite = "blogPage-module--mailer-lite--697e7";
export var main = "blogPage-module--main--294f0";
export var marginRight = "blogPage-module--margin-right--cbf22";
export var mobileAd = "blogPage-module--mobile-ad--0be69";
export var p = "blogPage-module--p--799a7";
export var relatedPost = "blogPage-module--related-post--1302a";
export var relatedPostImage = "blogPage-module--related-post-image--3a2a4";
export var relatedPostTitle = "blogPage-module--related-post-title--df803";
export var relatedPosts = "blogPage-module--related-posts--39f63";
export var relatedPostsBlock = "blogPage-module--related-posts-block--eb40d";
export var relatedPostsHeadline = "blogPage-module--related-posts-headline--87a03";
export var roundupGroups = "blogPage-module--roundup-groups--0400d";
export var roundupHeadline = "blogPage-module--roundup-headline--5dd1d";
export var roundupImage = "blogPage-module--roundup-image--3131e";
export var roundupLi = "blogPage-module--roundup-li--0290c";
export var roundupRecipeSummary = "blogPage-module--roundup-recipe-summary--6a0e2";
export var sellPara = "blogPage-module--sell-para--7f67a";
export var sidebar = "blogPage-module--sidebar--95ab8";
export var socialBlock = "blogPage-module--social-block--0a2b3";
export var socialIcon = "blogPage-module--social-icon--c8dff";
export var stickyAd = "blogPage-module--sticky-ad--856bd";
export var suggestRecipes = "blogPage-module--suggest-recipes--06903";
export var suggestRecipesBlock = "blogPage-module--suggest-recipes-block--eca24";
export var suggestRecipesHeading = "blogPage-module--suggest-recipes-heading--e160e";
export var suggestRecipesRecipe = "blogPage-module--suggest-recipes-recipe--76d08";
export var suggestRecipesRecipeImage = "blogPage-module--suggest-recipes-recipe-image--e80e9";
export var suggestRecipesRecipeTitle = "blogPage-module--suggest-recipes-recipe-title--4741b";
export var tagBlock = "blogPage-module--tag-block--a9bd6";
export var tags = "blogPage-module--tags--a19ae";
export var tagsLabel = "blogPage-module--tags-label--12734";
export var termsLink = "blogPage-module--terms-link--91181";
export var toc = "blogPage-module--toc--97fa2";
export var tocContents = "blogPage-module--toc-contents--5b51c";
export var tocH2 = "blogPage-module--toc-h2--05f05";
export var tocH3 = "blogPage-module--toc-h3--e6dcb";
export var tocHeading = "blogPage-module--toc-heading--9daa5";
export var tocInnerBox = "blogPage-module--toc-inner-box--ebbf8";
export var video = "blogPage-module--video--146d1";
export var videoBlock = "blogPage-module--video-block--550a7";
export var videoText = "blogPage-module--video-text--99c63";